<template>
    <div id="test" ref="test" style="user-select: none;" v-loading="loading">
        <div ref="content" id="content" class="content" :style="{'width':styleList.width+'px', 'height': styleList.height+'px'}" >
            <!-- Active点亮规则改变，框包含Pucker , IRC , SRF  , RPED, SRHM就保持点亮。 20240305 -->
            <div v-if="active" class="activeclass"><span class="spanCircle"></span>ACTIVE</div>
            <div :style="{'display': 'flex'}">
              <img
                id="bigImg"
                ref="myimg"
                :style="{ 'width':imgStyle.width+'px', 'height':imgStyle.height+'px','max-height':styleList.height+'px','max-width':styleList.width+'px', 'pointer-events': 'none', 'margin': '0 auto','display': 'block' }"
                :src="img"
                alt=""
              />
              <canvas  ref="mycanvas" class="canvas"></canvas>
            </div>
            <!-- <img
                id="bigImg"
                ref="img"
                :style="{ 'width':styleList.width+'px', 'height': styleList.height+'px', 'pointer-events': 'none', 'margin': '0 auto','display': 'block' }"
                :src="img"
                alt=""
            />
            <canvas  ref="mycanvas" class="canvas"></canvas> -->
        </div>
    </div>
</template>

<script>
import { openDraw, reDraw } from '@/utils/draw.js'
import { computedData, getImgStyle } from '@/utils/index'
export default {
  name: 'imgMark',
  props: {
    img: {
      type: String,
      default: '@/assets/imgages/1.jpg'
    },
    styleList: {
      type: Object
    },
    drawData: {
      type: Object,
      default: () => {}
    },
    dataList: {
      type: Array,
      default: () => []
    },
    markList: {
      type: Array,
      default: () => []
    },
    index: { /// 当前组件的数据位置
      type: Number,
      default: 0
    },
    imgStyle: {
      type: Object
    },
    itemIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    styleList (newval, oldval) {
      // this.$store.commit('setMarkList')
      openDraw(this.cav, this.markList, this.drawData, this.imgStyle)
    },
    drawData (newval, oldval) {
      console.log('drawData', this.drawData)
      if (newval.drawFlag && this.$store.state.list.length !== 0) {
        // this.initCanvas()
        openDraw(this.cav, this.markList, newval, this.imgStyle) // 画布初始化
      } else {
        openDraw(this.cav, this.markList, newval, this.imgStyle)
      }
    },
    imgStyle: {
      handler (newval, oldval) {
        this.imgStyleMark = newval
        this.canvas()
        openDraw(this.cav, this.markList, this.drawData, newval)
      },
      deep: true
    },
    index: {
      handler (newval, oldval) {
        this.getImgInfo(newval)
      },
      deep: true
    },
    scanIndex: {
      handler (newval, oldval) {
        this.getImgInfo(this.index)
      },
      deep: true
    }
  },
  computed: {
    active () {
      if (this.markList.lengh !== 0) {
        let ret = false
        for (let i = 0; i < this.markList.length; i++) {
          if (this.markList[i].id === 2 || this.markList[i].id === 3 || this.markList[i].id === 4 || this.markList[i].id === 5 || this.markList[i].id === 6 || this.markList[i].id === 8) {
            ret = true
            break
          } else {
            ret = false
          }
        }
        return ret
      } else { return false }
    }
  },
  data () {
    return {
      drawFlag: false,
      imgWidth_T: 0,
      imgHeight_T: 0,
      changedata: {},
      changeindex: 0,
      changeflag: 'push',
      findindex: 0,
      loading: false,
      interval: '',
      width: this.styleList.width,
      height: this.styleList.height,
      imgStyleMark: this.imgStyle
    }
  },
  mounted () {
    this.getImgInfo(this.index)
    setTimeout(() => {
      // this.getImgInfo(this.index)
      this.initCanvas() /// / 画布初始化
      this.loading = false
      console.log('this.markList', this.markList)
    }, 1000)
    window.changeData = (flag, data, i) => {
      if (flag === 'push') {
        setTimeout(() => { /// setTimeout等imgStyle更新
          const dat = computedData(data, 0, this.$store.state.styleImginfo)
          // console.log('(this.imgStyle',this.imgStyle)
          // console.log('(this.styleImginfo',this.$store.state.styleImginfo)
          this.$store.commit('insertDrawList', dat)
        }, 10)
      } else if (flag === 'delete') {
        const obj = {
          i: i
        }
        this.$store.commit('spliceDrawList', obj)
      } else if (flag === 'change') {
        setTimeout(() => {
          // console.log('this.$store.state.', this.$store.state.sliceData)
          const dat = computedData(data, 0, this.imgStyle)
          const obj = {
            i: i,
            data: dat
          }
          this.$store.commit('spliceDrawList', obj)
        }, 10)
      } else if (flag === 'findindex') {
        this.findindex = i
        // console.log('findeIndex', i)
        this.$store.commit('setfindIndex', i)
      }
    }

    console.log(this.active)
  },
  methods: {
    initFun () {
      this.initCanvas() /// / 画布初始化
      openDraw(this.cav, this.markList, this.drawData, this.imgStyle)
    },
    getMarkList (list) {
      // const list = this.$store.getters.getdrawList
      // console.log('list', list)
      if (list.length !== 0) {
        // const list2 = this.$store.getters.getMarkList
        // if (list2.length < list.length) {
        list.forEach((item, index) => {
          // const da = this.computedData(item, 1)
          // this.markList.push(da)
          // this.$store.commit('pushMarkList', da)
        })
        // }
      }
      const obj = {
        data: this.markList,
        index: this.index
      }
      // console.log('obj', obj)
      this.$store.commit('copyMarkList', obj)
    },
    /* 画布初始化 */
    initCanvas () {
      this.canvas()
      this.interval = ''
      if (!this.markList && this.markList.length === 0 && this.dataList.length !== 0) {
        this.interval = setInterval(() => {
          this.canvas()
        }, 1000)
      } else if (this.markList && this.markList.length !== 0 && this.dataList.length !== 0) {
        this.canvas()
        if (this.interval !== '') { clearInterval(this.interval) }
      } else {
        if (this.interval !== '') { clearInterval(this.interval) }
      }
    },
    async canvas () {
      // 计算使用变量
      // 初始化canvas宽高
      // const img = this.$refs.myimg
      console.log('this.imgStylethis.imgStylethis.imgStyle',this.imgStyle)
      this.cav = ''
      this.cav = this.$refs.mycanvas
      this.cav.width = this.styleList.width
      this.cav.height = this.styleList.height
      // if (this.drawData.drawFlag) {
      const ctx = this.cav.getContext('2d')
      ctx.strokeStyle = 'blue'
      ctx.lineWidth = 2
      // this.cav.style.cursor = 'crosshair'
      ctx.clearRect(0, 0, this.cav.width, this.cav.height)
      reDraw(this.cav, ctx, this.markList)
      this.loading = false
    },
    // /// 獲取圖片的真實寬高
    // async getImgInfo () {
    //   console.log('獲取圖片的真實寬高獲取圖片的真實寬高')
    //   const styleImg = await getImgStyle(this.img).then()
    //   const preImg = Number((styleImg.imgWidth_T / styleImg.imgHeight_T).toFixed(2))
    //   const preBox = Number((this.styleList.width / this.styleList.height).toFixed(2))
    //   // console.log(preImg, preBox)
    //   if (preImg < preBox) { /// 图片的比例小于box，以box的高为准，生成canvas
    //     this.height = Number(this.styleList.height)
    //     this.width = Number((this.styleList.height * preImg).toFixed(0))
    //   } else {
    //     this.height = Number((this.styleList.width / preImg).toFixed(0))
    //     this.width = Number(this.styleList.width)
    //   }
    //   const obj = {
    //     imgWidth_T: styleImg.imgWidth_T,
    //     imgHeight_T: styleImg.imgHeight_T,
    //     width: this.width,
    //     height: this.height
    //   }
    //   this.initCanvas()
    //   this.$store.commit('setImgStyleInfo', obj)
    // },
    /// 獲取圖片的真實寬高
    async getImgInfo (index) {
      const styleImg = await getImgStyle(this.img).then()
      const obj = {
        index: index,
        list: {
          imgWidth_T: styleImg.imgWidth_T,
          imgHeight_T: styleImg.imgHeight_T,
          width: this.styleList.width, /// 还是以box宽高计算坐标
          height: this.styleList.height/// 还是以box宽高计算坐标
        }
      }
      this.$store.commit('setImgStyleInfo2', obj)
      console.log('objvobjobjobj',obj)
      this.canvas()
      // console.log('state.sliceData2',this.$store.state.sliceData)
    },
  }
}
</script>

<style lang="less" scoped>

#test .content {
    /* //   width: 1200px;
    //   height: 800px; */
      background: none !important;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .activeclass{
        position: absolute;
        top:10px;
        right: 10px;
        width: 87px;
        height: 30px;
        // background-color: red;
        color:#D42525;
        // border: 1px solid #FFFFFF;
        // border-radius: 5px;
        font-size: 18px;
        z-index: 11;
    }
    .spanCircle{
      float:left;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #D42525;
      margin-top: 8px;
    }
.canvas {
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
z-index: 10;
/* width: 100%; */
/* // height: 100%; */
}
</style>
